import { render, staticRenderFns } from "./yeni.vue?vue&type=template&id=92b8b520&scoped=true&"
import script from "./yeni.vue?vue&type=script&lang=js&"
export * from "./yeni.vue?vue&type=script&lang=js&"
import style0 from "./yeni.vue?vue&type=style&index=0&id=92b8b520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b8b520",
  null
  
)

export default component.exports